import { render, staticRenderFns } from "./LayoutSubmissionView.vue?vue&type=template&id=173d3f15&"
import script from "./LayoutSubmissionView.vue?vue&type=script&lang=ts&"
export * from "./LayoutSubmissionView.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutSubmissionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports